/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
import React, {useEffect, useState} from "react"
import axios from "axios";
import BASEURL from "../../Constants";

const Home = () => {

    const [report, setReport] = useState([])
    const getReport = () =>{
        axios.get(BASEURL+'/api/dashboard-details').then(res=>{
            setReport(res.data)
            console.log(report)
        })
    }
    useEffect(() => {
        getReport()
    }, []);


    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Dashboard</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">Dashboard</li>
                </ol>

                <div className="my-card">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="card bg-primary text-white">
                                                <div className="card-header">
                                                    <h5>Total Order Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.total_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Total Paid Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.paid_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-warning text-white">
                                                <div className="card-header">
                                                    <h5>Total Due Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.due_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4 mb-5">
                                        <div className="col-md-4">
                                            <div className="card bg-info text-white">
                                                <div className="card-header">
                                                    <h5>Total Order</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.total_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-dark text-white">
                                                <div className="card-header">
                                                    <h5>Total Provider</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.total_provider}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Total Customer</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.total_customer}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </main>
    )
}
export default Home